import { render, staticRenderFns } from "./MenuMobile.vue?vue&type=template&id=6b546916"
import script from "./MenuMobile.vue?vue&type=script&lang=ts"
export * from "./MenuMobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports